import React, { useContext, useState,useEffect } from 'react';
import { xs_isMobile } from '../..';
import { UserContext } from '../betslip/UserConf';
import { PvrContext } from '../pvr/PvrConf';
import { getConfiguration } from '../utils';



export const ControlPanelContext = React.createContext(null);

function ControlPanelConf(props) {
	const conf = getConfiguration();
	const userContext = useContext(UserContext);
	const user = userContext.getUser();
	const pvrContext = useContext(PvrContext);
	const isMobile = xs_isMobile;
	
	const [controlPanelContext, setControlPanelContext] = useState({
		enabled : false,
		printTicketBoxShowed : false,
		printerSettingsBoxShowed : false,
		printerSettings : {
			paperFormat : 82,
			automaticPrint : (conf.aps? conf.aps : false),
			borderedTicket : conf.dft === 'BORDERED'
		},
		contextId : new Date().getTime(),
        updateContext(updt) {
			setControlPanelContext(prev => {
				return {...prev, ...updt};
            });
        },
		loadPrinterSettingsFromLocalStorage : function(){	
			if(this.enabled){
				let lsSettings = localStorage.getItem('XS_PRINT_SETTINGS');
				if(lsSettings != null){
					lsSettings = JSON.parse(lsSettings);
				}
				else{
					lsSettings = this.printerSettings;
				}
				this.setPrinterSettings(lsSettings);
			}
		},
		
		isAutoprint : function (){
			return this.printerSettings.automaticPrint;
		},
		
		
		setEnabled : function(enabled){
			this.enabled = enabled;
			this.updateContext({enabled});
		},
		
		toggleTicketBox : function(){
			const newValue = !this.printTicketBoxShowed;
			this.printTicketBoxShowed = newValue;
			this.updateContext({printTicketBoxShowed : newValue});
		},
		
		setStatusTicketBox : function(status){
			this.printTicketBoxShowed = status === 'open';
			const value = this.printTicketBoxShowed;
			this.updateContext({printTicketBoxShowed : value});
		},
		printTicketBoxIsShowable : function(){
			return this.enabled && this.printTicketBoxShowed;
		},
		
		
		togglePrintSettingsBox : function(){
			const newValue = !this.printTicketBoxShowed;
			this.printerSettingsBoxShowed = newValue;
			this.updateContext({printerSettingsBoxShowed : newValue});
		},
		
		setStatusPrintSettingsBox : function(status){
			this.printerSettingsBoxShowed = status === 'open';
			const value = this.printTicketBoxShowed;
			this.updateContext({printerSettingsBoxShowed : value});
		},
		printSettingsBoxIsShowable : function(){
			return this.enabled && this.printerSettingsBoxShowed;
		},
		
		toggleBorderedTicket : function (){
			const newValue = !this.printerSettings.borderedTicket;
			this.printerSettings.borderedTicket = newValue;
			const settings = this.printerSettings;
			this.setPrinterSettings(settings);
		},
		
		toggleAutomaticPrint : function (){
			const newValue = !this.printerSettings.automaticPrint;
			this.printerSettings.automaticPrint = newValue;
			const settings = this.printerSettings;
			this.setPrinterSettings(settings);
		},
		
		setPaperFormat : function(newValue){
			this.printerSettings.paperFormat = newValue;
			const settings = this.printerSettings;
			this.setPrinterSettings(settings);
		},
		
		setPrinterSettings: function(settings){
			if(this.enabled){
				this.printerSettings = settings;
				localStorage.setItem('XS_PRINT_SETTINGS', JSON.stringify(settings));
				this.updateContext({printerSettings : settings, contextId : new Date().getTime()});
			}
		}
	});
	
	useEffect(() => {
		if(!controlPanelContext.enabled){
			const isShop = user.operator || user.selfCashier; 
			const enabled = conf.cpe && !isMobile && !isShop && (user.logged || pvrContext.pvrSectionEnabled);
			controlPanelContext.setEnabled(enabled);
		}
	}, [user]);
	
	useEffect(() => {
		controlPanelContext.loadPrinterSettingsFromLocalStorage();
	}, [controlPanelContext.enabled]);

	

	
	return (
    	<ControlPanelContext.Provider value={controlPanelContext}>
			{props.children}
    	</ControlPanelContext.Provider>
	);	
	
}

export default ControlPanelConf;